const tablesSettings = {
  statusColumnMinWidth: 300,
};

export default tablesSettings;
